<template>
    <form method="post"
          id="make-appointment"
          class="form-order position-relative"
          :action="action"
          @submit.prevent="onSubmit"
          @keydown="form.errors.clear($event.target.name)">

        <div class="form-group">
            <input type="text"
                   name="name"
                   class="form-control"
                   :placeholder="Lang.get('common.name')"
                   v-model="form.name"
            >
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('name')"
                  v-text="form.errors.get('name')">
            </span>
        </div>

        <div class="form-group">
            <input type="text"
                   name="phone"
                   class="form-control mobilephone-input-mask"
                   :placeholder="Lang.get('common.phone')"
                   v-model="form.phone"
            >
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('phone')"
                  v-text="form.errors.get('phone')">
            </span>
        </div>

        <!--<div class="form-group">-->
        <!--<datepicker :language="ru" :monday-first="true">-->
        <!--<span slot="afterDateInput" class="animated-placeholder">Выберете дату</span>-->
        <!--</datepicker>-->
        <!--</div>-->

        <div class="form-group date-string">
            <label class="d-none" for="contact-date">Дата*</label>
            <input type="date" id="contact-date" v-model="form.date" name="visit-date" placeholder="Дата визита"
                   class="form-control"
                   @change="form.errors.clear('date')"
                   min="2018-01-07T09:00">
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('date')"
                  v-text="form.errors.get('date')">
            </span>
            <select v-model="form.time"
                    class="form-control time-select">
                <option value="" selected>Время</option>
                <option v-for="option in options" v-bind:value="option.value">
                    {{ option.text }}
                </option>
            </select>
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('time')"
                  v-text="form.errors.get('time')">
            </span>
        </div>

        <div class="form-group">
            <textarea name="message"
                      :placeholder="Lang.get('common.target')"
                      class="form-control"
                      v-model="form.message">{{ form.message }}</textarea>
            <span class="help is-danger text-danger"
                  v-if="form.errors.has('message')"
                  v-text="form.errors.get('message')">
            </span>
        </div>

        <input class="btn btn-success custom-button my-btn w-100"
               type="submit"
               :disabled="form.errors.any()"
               :value="Lang.get('common.send')">
        <widget-loading v-if="form.loading" color="#fff"></widget-loading>
    </form>
</template>

<script>
    import WidgetLoading from '../elements/WidgetLoading';
    import Datepicker from 'vuejs-datepicker';

    export default {
        name: "FormMakeAppointment",
        components: {
            WidgetLoading,
            Datepicker,
        },
        data() {
            return {
                form: new Form({
                    name: '',
                    phone: '',
                    message: '',
                    date: '',
                    time: '',
                    type: 'make-appointment',
                    url: location,
                }),
                selected: 'empty',
                options: [
                    { text: '9:00', value: '9_0' },
                    { text: '9:30', value: '9_30' },
                    { text: '10:00', value: '10_0' },
                    { text: '10:30', value: '10_30' },
                    { text: '11:00', value: '11_0' },
                    { text: '11:30', value: '11_30' },
                    { text: '12:00', value: '12_0' },
                    { text: '12:30', value: '12_30' },
                    { text: '13:00', value: '13_0' },
                    { text: '13:30', value: '13_30' },
                    { text: '14:00', value: '14_0' },
                    { text: '14:30', value: '14_30' },
                    { text: '15:00', value: '15_0' },
                    { text: '15:30', value: '15_30' },
                    { text: '16:00', value: '16_0' },
                    { text: '16:30', value: '16_30' },
                    { text: '17:00', value: '17_0' },
                    { text: '17:30', value: '17_30' },
                    { text: '18:00', value: '18_0' },

                ],
                action: '/make-appointment',
                Lang,
            }
        },
        methods: {
            onSubmit() {
                this.form.submit(this.$el.method, this.$el.action).then(res => {
                    document.querySelector('#make-appointment').innerHTML = res;
                }).catch(
                    error => console.log(error)
                );
            },
        },
        mounted() {
            helpers.setInputMask('mobilephone');
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/FormMakeAppointment.vue